var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { staticClass: "bg-white shadow py-5 px-3 mb-4" },
    [
      _c("vs-col", { attrs: { "vs-lg": "12" } }, [
        _c("div", { staticClass: "d-block" }, [
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-bottom": "5px" } },
            [
              _c(
                "span",
                [
                  _c("feather-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "InboxIcon" }
                  }),
                  _vm._v(" Bandeja de entrada ")
                ],
                1
              ),
              _vm.rangeSelected.valor !== "personalizado"
                ? _c("span", [
                    _vm._v(" " + _vm._s(_vm.rangeSelected.nombre) + " ")
                  ])
                : _vm._e(),
              _vm.rangeSelected.valor === "personalizado"
                ? _c(
                    "span",
                    [
                      _vm._v(" entre el "),
                      _c("datetime", {
                        attrs: {
                          "input-class": "form-control input-date",
                          phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                          "value-zone": "local",
                          format: "yyyy-MM-dd",
                          "data-cy": "start-time"
                        },
                        model: {
                          value: _vm.rangeFrom,
                          callback: function($$v) {
                            _vm.rangeFrom = $$v
                          },
                          expression: "rangeFrom"
                        }
                      }),
                      _vm._v(" y el "),
                      _c("datetime", {
                        attrs: {
                          "input-class": "form-control input-date",
                          phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                          "value-zone": "local",
                          format: "yyyy-MM-dd",
                          "data-cy": "end-time"
                        },
                        model: {
                          value: _vm.rangeUntil,
                          callback: function($$v) {
                            _vm.rangeUntil = $$v
                          },
                          expression: "rangeUntil"
                        }
                      }),
                      _c(
                        "span",
                        [
                          _c("vs-button", {
                            staticClass: "ml-3 d-inline",
                            attrs: {
                              radius: "",
                              color: "primary",
                              type: "border",
                              icon: "search",
                              size: "small"
                            },
                            on: {
                              click: function($event) {
                                return _vm.applyFilters()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "vs-dropdown",
                {
                  staticStyle: { "margin-left": "15px" },
                  attrs: { "vs-trigger-click": "" }
                },
                [
                  _c(
                    "a",
                    { staticClass: "a-icon", attrs: { href: "#" } },
                    [
                      _vm._v(" Cambiar "),
                      _c("vs-icon", { attrs: { icon: "expand_more" } })
                    ],
                    1
                  ),
                  _c(
                    "vs-dropdown-menu",
                    _vm._l(_vm.ranges, function(range) {
                      return _c(
                        "vs-dropdown-item",
                        {
                          key: range.valor,
                          staticStyle: { width: "200px" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.selectRange(range)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(range.nombre) + " ")]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "vs-col",
        { attrs: { "vs-lg": "1" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Buscar",
                  expression: "'Buscar'"
                }
              ],
              staticClass: "btn-icon rounded-circle p-3",
              attrs: { variant: "primary", size: "sm" },
              on: {
                click: function($event) {
                  return _vm.applyFilters()
                }
              }
            },
            [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
            1
          )
        ],
        1
      ),
      _c("vs-col", { attrs: { "vs-lg": "9" } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchText,
              expression: "searchText"
            }
          ],
          staticClass: "form-control",
          attrs: {
            placeholder: "Buscar por asunto o nombre de adjunto...",
            "data-cy": "search-received"
          },
          domProps: { value: _vm.searchText },
          on: {
            keypress: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.applyFilters($event)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchText = $event.target.value
            }
          }
        })
      ]),
      _c(
        "vs-col",
        { attrs: { "vs-lg": "2" } },
        [
          _c(
            "b-button",
            {
              staticClass: "w-100",
              attrs: {
                variant:
                  _vm.sortOrder === "desc"
                    ? "outline-primary"
                    : "outline-secondary",
                size: "sm"
              },
              on: { click: _vm.toggleSort }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-1",
                attrs: {
                  icon:
                    _vm.sortOrder === "desc" ? "ArrowDownIcon" : "ArrowUpIcon",
                  size: "14"
                }
              }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.sortOrder === "desc" ? "Más recientes" : "Más antiguos"
                  ) +
                  " "
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }